import React, { Component } from "react";
import _ from "lodash";
import { multiLanguage } from "../../hoc";
import { Slider } from "../../components";

const imageSlider = [
  { image: "https://lagunaproperty.com/images/com/Laguna.JPG" },
  { image: "https://lagunaproperty.com/images/com/Cassia.JPG" },
  { image: "https://lagunaproperty.com/images/com/Angsana.jpg" },
  { image: "https://lagunaproperty.com/images/com/Dhawa.jpg" },
  { image: "https://lagunaproperty.com/images/kim.jpg" },
];

const logoImage = [
  { image: "https://lagunaproperty.com/images/x1.png" },
  { image: "https://lagunaproperty.com/images/x2.png" },
  { image: "https://lagunaproperty.com/images/x3.png" },
  { image: "https://lagunaproperty.com/images/x4.png" },
  { image: "https://lagunaproperty.com/images/x5.png" },
];

@multiLanguage()
export default class Community extends Component {
  state = {
    logoAcive: 0,
  };

  countlogoAcive = () => {
    setInterval(() => {
      const { logoAcive } = this.state;
      const nextLogoAcive =
        logoAcive === _.size(logoImage) - 1 ? 0 : logoAcive + 1;
      this.setState({ logoAcive: nextLogoAcive });
    }, 5000);
  };

  componentDidMount = () => {
    this.countlogoAcive();
  };

  render() {
    const { logoAcive } = this.state;
    return (
      <div className="section7-community">
        <div className="bg-left">
          <div className="container-content">
            <h2>Banyan Group Community</h2>
            <p>Invitation to Banyan Tree organized events worldwide</p>
            <div class="logo-group">
              {_.map(logoImage, (logo, key) => {
                return (
                  <div
                    class={`logo-img ${logoAcive === key ? "logo-active" : ""}`}
                  >
                    <img alt="" src={logo.image} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="container-slider">
          <Slider
            type="type-background"
            sliderRef={this.sliderRef}
            items={imageSlider}
            settings={{ arrows: false }}
            uiRenderer={(item, index) => {
              return (
                <div
                  className="img-background"
                  style={{
                    backgroundImage: `url(${item.image})`,
                    backgroundPosition: item.backgroundPosition,
                  }}
                />
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Community.js